"use client"

import { useEffect, useRef, useState } from "react"
import { Icon } from "./icons.tsx"

export const CatalogBrandNavigation = ({ brands, onChange, value }: { readonly brands: readonly string[]; readonly onChange: (brand: string) => void; readonly value: string }) => {
  const rail = useRef<HTMLDivElement>(null)
  const [edges, setEdges] = useState({ left: false, right: false })

  useEffect(() => {
    const element = rail.current
    if (element === null || brands.length === 0) return
    let frame = 0
    const measure = () => {
      const left = element.scrollLeft > 1
      const right = element.scrollWidth - element.clientWidth - element.scrollLeft > 1
      setEdges((previous) => (previous.left === left && previous.right === right ? previous : { left, right }))
    }
    const schedule = () => {
      cancelAnimationFrame(frame)
      frame = requestAnimationFrame(measure)
    }
    const resize = new ResizeObserver(schedule)
    resize.observe(element)
    element.addEventListener("scroll", schedule, { passive: true })
    measure()
    return () => {
      cancelAnimationFrame(frame)
      resize.disconnect()
      element.removeEventListener("scroll", schedule)
    }
  }, [brands])

  const move = (direction: number) => {
    const element = rail.current
    if (element !== null) element.scrollBy({ left: direction * element.clientWidth * 0.75, behavior: "instant" })
  }

  return (
    <div className="catalog-brand-navigation" data-scroll-left={edges.left} data-scroll-right={edges.right}>
      <button aria-label="이전 브랜드 보기" className="catalog-brand-arrow" disabled={!edges.left} onClick={() => move(-1)} type="button">
        <Icon name="back" />
      </button>
      <div aria-label="브랜드" className="catalog-chips" ref={rail} role="tablist">
        {["all", ...brands].map((brand) => (
          <button aria-selected={value === brand} className={value === brand ? "is-active" : undefined} key={brand} onClick={() => onChange(brand)} role="tab" type="button">
            {brand === "all" ? "전체" : brand}
          </button>
        ))}
      </div>
      <button aria-label="다음 브랜드 보기" className="catalog-brand-arrow catalog-brand-arrow-next" disabled={!edges.right} onClick={() => move(1)} type="button">
        <Icon name="back" />
      </button>
    </div>
  )
}
